import config from "@/config"
import http from "@/utils/request"

export default {
    info:{
        url: `${config.API_URL}/bwmall/admin/user/index`,
        name: "获取用户信息",
        get: async function(params){
            return await http.get(this.url, params);
        }
    },
    infoEdit:{
        url: `${config.API_URL}/bwmall/admin/user/edit`,
		name: "编辑用户个人信息",
		post: async function(params){
			return await http.post(this.url, params);
		},
        get: async function(params){
			return await http.get(this.url, params);
		},
    },
    modify:{
        url: `${config.API_URL}/bwmall/admin/user/modify`,
		name: "变更用户资料",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    changeMoney:{
        url: `${config.API_URL}/bwmall/admin/user/changeMoney`,
		name: "变更用户余额",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    editPw:{
        url: `${config.API_URL}/bwmall/admin/user/editPw`,
		name: "变更用户密码",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    wallet:{
        index:{
            url: `${config.API_URL}/bwmall/admin/bill/index`,
            name: "获取钱包记录",
            get: async function(params){
                return await http.get(this.url, params);
            }
        },
    },
    // 用户充值管理（/manage/recharge/*，对应后端 manage.Recharge 控制器）
    recharge: {
        // 充值记录列表（filter/op 搜索：order_id/uid/paid/mobile）
        log: {
            url: `${config.API_URL}/manage/recharge/log`,
            name: "充值记录",
            get: async function(params){
                return await http.get(this.url, params);
            }
        },
        // 充值套餐列表
        package: {
            url: `${config.API_URL}/manage/recharge/package`,
            name: "充值套餐列表",
            get: async function(params){
                return await http.get(this.url, params);
            }
        },
        // 套餐添加/编辑
        packageSave: {
            url: `${config.API_URL}/manage/recharge/packageSave`,
            name: "保存充值套餐",
            post: async function(data){
                return await http.post(this.url, data);
            }
        },
        // 套餐删除（ids 逗号分隔）
        packageDel: {
            url: `${config.API_URL}/manage/recharge/packageDel`,
            name: "删除充值套餐",
            post: async function(data){
                return await http.post(this.url, data);
            }
        },
        // 套餐启用/停用
        packageSwitch: {
            url: `${config.API_URL}/manage/recharge/packageSwitch`,
            name: "切换套餐状态",
            post: async function(data){
                return await http.post(this.url, data);
            }
        },
        // 充值设置（充值说明富文本）
        set: {
            url: `${config.API_URL}/manage/recharge/set`,
            name: "充值设置",
            get: async function(){
                return await http.get(this.url);
            },
            post: async function(data){
                return await http.post(this.url, data);
            }
        }
    },
    // 用户提现管理（/manage/extract/*，对应后端 manage.Extract 控制器）
    withdraw: {
        // 提现记录列表（filter/op 搜索：user_id/status/extract_type/mobile/nickname）
        log: {
            url: `${config.API_URL}/manage/extract/log`,
            name: "提现记录",
            get: async function(params){
                return await http.get(this.url, params);
            }
        },
        // 提现审核（status -1未通过/0审核中/1已提现；失败必填 fail_msg）
        logEdit: {
            url: `${config.API_URL}/manage/extract/logEdit`,
            name: "提现审核",
            post: async function(data){
                return await http.post(this.url, data);
            }
        },
        // 提现记录删除（id 逗号分隔）
        logDel: {
            url: `${config.API_URL}/manage/extract/logDel`,
            name: "删除提现记录",
            post: async function(data){
                return await http.post(this.url, data);
            }
        },
        // 提现账户绑定列表
        bind: {
            url: `${config.API_URL}/manage/extract/bind`,
            name: "提现账户绑定列表",
            get: async function(params){
                return await http.get(this.url, params);
            }
        },
        // 绑定信息编辑
        bindEdit: {
            url: `${config.API_URL}/manage/extract/bindEdit`,
            name: "编辑提现绑定",
            post: async function(data){
                return await http.post(this.url, data);
            }
        },
        // 绑定删除（id 逗号分隔）
        bindDel: {
            url: `${config.API_URL}/manage/extract/bindDel`,
            name: "删除提现绑定",
            post: async function(data){
                return await http.post(this.url, data);
            }
        },
        // 提现配置（说明/手续费/最低金额）
        config: {
            url: `${config.API_URL}/manage/extract/config`,
            name: "提现配置",
            get: async function(){
                return await http.get(this.url);
            },
            post: async function(data){
                return await http.post(this.url, data);
            }
        }
    },
    decorateAdd:{
        url: `${config.API_URL}/bwmall/admin.decorate/add`,
		name: "添加装修信息",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    level:{
        url: `${config.API_URL}/bwmall/admin/user/level/index`,
        name: "等级列表",
        get: async function(params){
            return await http.get(this.url, params);
        }
    },
    levelEdit:{
        url: `${config.API_URL}/bwmall/admin/user/level/edit`,
		name: "修改等级信息",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    levelAdd:{
        url: `${config.API_URL}/bwmall/admin/user/level/add`,
		name: "添加",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
	levelDel:{
        url: `${config.API_URL}/bwmall/admin/user/level/del`,
		name: "删除",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    levelModify:{
        url: `${config.API_URL}/bwmall/admin/user/level/modify`,
		name: "变更",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    levelLog:{
        url: `${config.API_URL}/bwmall/admin/user/level/log/index`,
		name: "购买记录",
		get: async function(params){
			return await http.get(this.url, params);
		}
    },
}
